import axios from "axios";

const api = axios.create({
    // baseURL: "/", // Set your base API URL
    headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
    },
    withCredentials: true,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
});

// Add a request interceptor
api.interceptors.request.use(
    (config) => {
        // Rely on axios XSRF handling (X-XSRF-TOKEN from the XSRF-TOKEN cookie).
        // Do not send X-CSRF-TOKEN from the static meta tag — it goes stale after
        // Inertia navigations and takes precedence over the cookie in Laravel.

        // Enable broadcast(...)->toOthers() so the sender does not also get
        // their own message event when they have the thread open.
        const socketId = window.Echo?.socketId?.();
        if (socketId) {
            config.headers["X-Socket-Id"] = socketId;
        }

        // If data is FormData, remove Content-Type so the browser sets the boundary.
        if (config.data instanceof FormData && config.headers) {
            if (typeof config.headers.delete === "function") {
                config.headers.delete("Content-Type");
            } else {
                delete config.headers["Content-Type"];
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

api.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        // Handle errors globally
        console.error("API Error:", error.response || error.message);
        return Promise.reject(error);
    },
);

export default {
    get: (url, params = {}, config = {}) => api.get(url, { params, ...config }),
    post: (url, data = {}, config = {}) => api.post(url, data, config),
    put: (url, data = {}, config = {}) => api.put(url, data, config),
    delete: (url, data = {}, config = {}) =>
        api.delete(url, { data, ...config }),
};
